/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import clsx from 'clsx';
import { Typography } from '@material-ui/core';
import { ImageAspectRatio } from 'models/forms';
import Preview from './Preview';
import useStyles from './style';

interface Props {
  image: string | null;
  text: string | null;
  aspectRatio: ImageAspectRatio;
}

const EmptyImagePreview: React.FC<Props> = (props) => {
  const { aspectRatio, image, text } = props;
  const classes = useStyles();

  return (
    <div
      className={clsx({
        [classes.containerHorizontal]: aspectRatio === ImageAspectRatio.AR_9_16,
        [classes.containerVertical]: aspectRatio === ImageAspectRatio.AR_2_3,
      })}
    >
      {image ? (
        <Preview aspectRatio={aspectRatio} image={image} text={text} />
      ) : (
        <Typography variant='body2' className={classes.noImageText}>
          Add image to see preview
        </Typography>
      )}
    </div>
  );
};

export default EmptyImagePreview;
